export default __webpack_public_path__ + "static/media/banner-seguro-produtor-rural.22c6cecc.jpg";